var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartups1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209.438,
    height: 209.438,
    viewBox: "0 0 209.438 209.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    d: "M0-682.665H209.437v209.437H0Z",
    transform: "translate(0 682.665)",
    fill: "#1c6bfe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Startups",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2444",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2446",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2452",
    transform: "translate(42.79 64.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2454",
    d: "M-56.919,0l-8.123,7.12A47.493,47.493,0,0,0-80.018,31.834a74.706,74.706,0,0,0-2.088,17.908A5.3,5.3,0,0,0-76.8,54.98h25.742",
    transform: "translate(82.109)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2456",
    transform: "translate(43.734 101.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2458",
    d: "M0,0H26.387",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2460",
    transform: "translate(141.122 63.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2462",
    d: "M0,0,8.458,7.414A47.492,47.492,0,0,1,23.434,32.127a74.7,74.7,0,0,1,2.087,17.908,5.3,5.3,0,0,1-5.307,5.238H15.148",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2464",
    transform: "translate(136.306 119.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2466",
    d: "M-12.93,0h-5.722",
    transform: "translate(18.652)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2468",
    transform: "translate(139.316 101.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2470",
    d: "M-59.622,0H-86.009",
    transform: "translate(86.009 0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2472",
    transform: "translate(67.409 3.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2474",
    d: "M-11.476-97.8c-.925,2.722-1.756,5.564-2.469,8.525A97.017,97.017,0,0,0-15.531-52.8C-13.647-39.653-9.045-14.3.424,5.8A5.667,5.667,0,0,0,5.55,9.048H35.961A5.667,5.667,0,0,0,41.087,5.8C50.555-14.3,55.157-39.653,57.041-52.8a97.009,97.009,0,0,0-1.586-36.483,100.79,100.79,0,0,0-29.1-49.615,8.241,8.241,0,0,0-11.2,0A101.775,101.775,0,0,0-5.9-110.965",
    transform: "translate(16.555 141.088)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2476",
    transform: "translate(78.721 135.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2478",
    d: "M0,0H51.995",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2480",
    transform: "translate(86.37 46.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2482",
    d: "M-82.916-41.458A18.348,18.348,0,0,1-101.265-23.11a18.348,18.348,0,0,1-18.348-18.348,18.348,18.348,0,0,1,18.348-18.348A18.348,18.348,0,0,1-82.916-41.458Z",
    transform: "translate(119.613 59.807)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2484",
    transform: "translate(75.873 163.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2486",
    d: "M-13.407,0s-5.117,6.574-5.934,13.56",
    transform: "translate(19.341)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2488",
    transform: "translate(54.901 174.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2490",
    d: "M-13.6-53.957a12.934,12.934,0,0,1-6.017-10.937A12.944,12.944,0,0,1-6.67-77.837,12.928,12.928,0,0,1,3.806-72.5",
    transform: "translate(19.613 77.837)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2492",
    transform: "translate(17.684 176.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2494",
    d: "M-58.964-29.862a12.927,12.927,0,0,0-5.12-10.585,12.943,12.943,0,0,0-18.135,2.491c-6.85,9.031-.459,22.206,10.048,24.467",
    transform: "translate(85.06 43.079)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2496",
    transform: "translate(39.172 174.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2498",
    d: "M0-10.182a9,9,0,0,1,12.293-3.3,8.987,8.987,0,0,1,4.456,6.855",
    transform: "translate(0 14.688)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2500",
    transform: "translate(127.631 163.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2502",
    d: "M0,0S5.117,6.574,5.934,13.56",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2504",
    transform: "translate(131.117 174.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2506",
    d: "M-39.32-53.957A12.934,12.934,0,0,0-33.3-64.894,12.944,12.944,0,0,0-46.247-77.837,12.928,12.928,0,0,0-56.723-72.5",
    transform: "translate(56.723 77.837)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2508",
    transform: "translate(165.655 176.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2510",
    d: "M-.006-29.862a12.927,12.927,0,0,1,5.12-10.585,12.943,12.943,0,0,1,18.135,2.491c6.85,9.031.459,22.206-10.048,24.467",
    transform: "translate(0.009 43.079)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2512",
    transform: "translate(153.517 174.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2514",
    d: "M-37.843-10.182a9,9,0,0,0-12.293-3.3,8.987,8.987,0,0,0-4.456,6.855",
    transform: "translate(54.592 14.688)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2516",
    transform: "translate(91.34 153.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2518",
    d: "M-45.365,0h-13.4c-11.717,9.34-6.714,26.57,4.923,33.674a3.413,3.413,0,0,0,3.55,0C-38.651,26.57-33.648,9.34-45.365,0Z",
    transform: "translate(65.442)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2520",
    transform: "translate(81.812 26.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2522",
    d: "M-103.518,0h-45.814",
    transform: "translate(149.332)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartups1);
export default __webpack_public_path__ + "static/media/Startups (1).513dd56146435627d25761f23ee78bd0.svg";
export { ForwardRef as ReactComponent };